import { render } from "./VoiceToText.vue?vue&type=template&id=51f0b4e8&scoped=true"
import script from "./VoiceToText.vue?vue&type=script&lang=js"
export * from "./VoiceToText.vue?vue&type=script&lang=js"

import "./VoiceToText.vue?vue&type=style&index=0&id=51f0b4e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f0b4e8"]])

export default __exports__